<template>
  <div class="filters-block filters-scenes">
    <div class="filters">
      <h3 class="filters-block__title">Filter</h3>
    </div>
    <div class="filters-block__filters">
      <div class="filters-block__sort">
        <div class="select-wrapper">
          <select class="query-control sort-type" v-model="sortType">
            <option value="_createdAt">Date Created</option>
            <option value="release">Date Released</option>
            <option value="title">Title</option>
            <option value="views">Views</option>
            <option value="popularity">Rating</option>
          </select>
        </div>
        <div class="select-wrapper">
          <select class="query-control sort-order" v-model="sortOrder">
            <option value="asc">Ascending</option>
            <option value="desc">Descending</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sanity from "../sanity";

export default {
  name: 'FiltersScenes',
  props: {
    scenes: Array
  },
  data() {
    return {
      sortType: '_createdAt',
      sortOrder: 'asc'
    };
  },
  watch: {
    $route: "fetchData",
    sortType(newSortType, oldSortType) {
      this.sortType = newSortType;
      if (newSortType != oldSortType) {
        this.updateSceneSorting();
      }
    },
    sortOrder(newSortOrder, oldSortOrder) {
      this.sortOrder = newSortOrder;
      if (newSortOrder != oldSortOrder) {
        this.updateSceneSorting();
      }
    }
  },
  methods: {
    async updateSceneSorting() {
      let query = `*[_type == "scene"] {
        _id,
        name,
        release,
        models,
        studios,
        thumbnail,
        screencaps,
        models[]->,
        studios[]->,
        favorite
      }[0...50] | order(${this.sortType} ${this.sortOrder})`;
      
      sanity.fetch(query).then(
        scenes => {
          this.scenes = scenes;
        },
        error => {
          this.error = error;
        }
      );

      /*
      try {
        const res = await fetch('https://yesno.wtf/api')
        this.answer = (await res.json()).answer
      } catch (error) {
        this.answer = 'Error! Could not reach the API. ' + error
      }
      */
    }
  }
};
</script>

<style scoped>
.filters-block {
  display: flex;
  justify-content: space-between;
  background-color: var(--color-mono-4);
  padding: 18px 36px;
}
.filters-block__title {
  font-size: 1rem;
  font-weight: 400;
  margin: 0;
}
.filters-block__filters {
display: flex;
}
.filters-block__sort {
  display: flex;
}
.filters-block__sort select {
  appearance: none;
  position: relative;
  background-color: var(--color-mono-3);
  border-color: var(--color-mono-2);
  color: var(--color-mono-0);
  padding: 6px 24px 6px 12px;
  margin-left: 16px;
  border-radius: 16px;
}
.select-wrapper {
  position: relative;
}
.filters-block__sort .select-wrapper:after {
  content: '';
    display: block;
    position: absolute;
    width: 0;
    height: 0;
    top: 55%;
    right: 12px;
    transform: translateY(-50%);
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 3px solid var(--color-mono-0);
}
</style>
 